import { jsonBody, NO_TIMEOUT, webApiClient } from 'Shared/web_api_client';

/**
 * The crop and marker saves live with the library that owns the image:
 * product images on the admin product-images routes, the rest in the user's
 * media.
 */
export type ImageType = 'GuideImage' | 'CartImage';

function imagesPath(type: ImageType): string {
   return type === 'CartImage' ? 'admin/product-images' : 'user/media/images';
}

/** Queues the crop's render; resolves with the job to poll. */
export async function postCrop(
   type: ImageType,
   imageid: number,
   markup: string,
   ratio: string | null
): Promise<string> {
   const client = await webApiClient();
   const { jobID } = await client.post<{ jobID: string }>(
      `${imagesPath(type)}/${imageid}/crop`,
      'image-crop',
      { ...jsonBody({ markup, ratio }), ...NO_TIMEOUT }
   );
   return jobID;
}

export async function getCropStatus<T>(
   type: ImageType,
   jobID: string,
   accepts: string | null
): Promise<T> {
   const client = await webApiClient();
   const query = accepts ? `?accepts=${encodeURIComponent(accepts)}` : '';
   return client.get<T>(`${imagesPath(type)}/crop/${encodeURIComponent(jobID)}${query}`, {
      statName: 'image-crop-status',
   });
}

/**
 * Renders the markers onto a new image, which can take a while; resolves
 * with that image as the Media Manager loads it.
 */
export async function postMarkers<T>(type: ImageType, imageid: number, markup: string): Promise<T> {
   const client = await webApiClient();
   return client.post<T>(`${imagesPath(type)}/${imageid}/markers`, 'image-markers', {
      ...jsonBody({ markup }),
      ...NO_TIMEOUT,
   });
}
